import "./SelectDealsModal.css";

import { Dispatch, SetStateAction } from "react";

import { SelectData } from "../../../../../../models";
import { ServiceError } from "../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, KanaTooltip, Modal, Row } from "../../../../../../widget";
import { AutocompleteMultiSelect } from "../../../../../../widget/forms/AutocompleteMultiSelect";
import { useSelectDealsModal } from "./useSelectDealsModal";

interface SelectDealsModalProps {
  errors: ServiceError[] | undefined;
  roadmapDealUuids: string[];
  setRoadmapDealUuids: Dispatch<SetStateAction<string[]>>;
  dealsMultiSelectData: SelectData | undefined;
  onSaveDealsSelectData: () => void;
  show: boolean;
  closePanel: () => void;
  fetchSelectData: (name?: string) => Promise<void>;
}

export const SelectDealsModal = ({
  errors,
  roadmapDealUuids,
  setRoadmapDealUuids,
  dealsMultiSelectData,
  onSaveDealsSelectData,
  show,
  closePanel,
  fetchSelectData,
}: SelectDealsModalProps): JSX.Element => {
  const {
    saveDealsSelectDataAndCloseDropdown,
    onDropdownVisibleChange,
    closePanelAndDropdown,
    open,
    dealsMultiSelectDataOrder,
  } = useSelectDealsModal({
    roadmapDealUuids,
    dealsMultiSelectData,
    closePanel,
    onSaveDealsSelectData,
  });

  return (
    <Modal onClose={closePanelAndDropdown} show={show} title="Select deals to add to roadmap">
      <Row spacingV="xl" justify="center">
        <Column span={8}>
          <p className="body1">
            To populate the portfolio roadmap, select up to 15 deals from the dropdown below. Only deals with an
            assigned workflow will appear on the roadmap. To assign workflows, visit the workflows section.
          </p>
        </Column>
      </Row>
      {errors && errors.length > 0 && (
        <Row spacingV="xl">
          <Column span={6} offset={3}>
            <ErrorBox text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <form className="SelectDealsModalForm" onSubmit={(e) => saveDealsSelectDataAndCloseDropdown(e)}>
        <Row spacingV="xl" justify="center">
          <Column span={6}>
            <AutocompleteMultiSelect
              label="Add deals"
              placeholder="Search deals"
              className="EditDealsDropdown"
              tooltip={
                <KanaTooltip
                  tooltipHeader=""
                  // TODO: ADD when deal workflows implemented You can assign a workflow here [link to workflows section].
                  tooltipText="If you can't see your deal here, it doesn't have a workflow assigned."
                />
              }
              values={roadmapDealUuids}
              data={dealsMultiSelectData ?? []}
              order={dealsMultiSelectDataOrder}
              onChange={(values) => setRoadmapDealUuids(values)}
              onTypeSearch={fetchSelectData}
              overrideOpen={open}
              overrideOnDropdownVisibleChange={onDropdownVisibleChange}
              getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
            />
          </Column>
        </Row>
        <Row spacingV="xl" justify="center">
          <Column span={6}>
            <ActionButtons onCancel={closePanelAndDropdown} fullWidth />
          </Column>
        </Row>
      </form>
    </Modal>
  );
};
